import React from 'react';
import './footer.scss';

import fscsImg from '../../assets/images/fscs-logo.svg';
import {footerLinks} from './footerLinks';

const DashboardFooter = () => {
  return (
    <footer className='footer footer--dashboard'>
      <div className='footer__wrapper'>
        <ul className='footer__links'>
          <li className='footer__link footer__link--large-only' key="-1">© Investec {(new Date()).getFullYear()}</li>
          {renderFooterLinks(footerLinks)}
          <li className='footer__link footer__link--small-only' key="-2">© Investec {(new Date()).getFullYear()}</li>
        </ul>
        <div className='footer__image footer__fscs-logo'>
          <a target="_blank" href="https://www.fscs.org.uk" rel="noreferrer">
            <img src={fscsImg} className='footer__fscs-logo-img' alt="FSCS Protected" />
          </a>
        </div>
      </div>
    </footer>
  );
};

const renderFooterLinks = (/** @type {import('./FooterTypes').FooterLink[]} */ links) => {
  return links.map(({ link, text }, i) => (
    <li className='footer__link' key={i}>
      <a target="_blank" href={link} rel="noreferrer">{text}</a>
    </li>
  ));
};


export default DashboardFooter;
